import React, { Fragment, useState } from "react";

import { Link } from "@/libraries/design/components";

import { Modal } from "./modal";

export interface LinkModalProps {
    text: string;
    content: (height: string) => React.ReactNode;
    isModalOpen?: boolean;
    setIsModalOpen?: (isOpen: boolean) => void;
}

export const LinkModal = ({
    text,
    content,
    isModalOpen,
    setIsModalOpen
}: LinkModalProps) => {
    const [isOpen, setIsOpen] = useState(false);

    // If state is passed in, use that instead of local state
    const isOpenState = isModalOpen ? isModalOpen : isOpen;
    const setIsOpenState = setIsModalOpen ? setIsModalOpen : setIsOpen;

    return (
        <Fragment>
            <Link
                href="#"
                type="modal"
                onClick={(event) => {
                    event.preventDefault();
                    setIsOpenState(true);
                }}
                text={text}
            />
            <Modal
                content={content}
                closeModal={() => setIsOpenState(false)}
                isOpen={isOpenState}
                isContentModal={true}
            />
        </Fragment>
    );
};
